// Copyright © 2021 Move Closer
import { onMounted, ref, toRefs, watch } from '@vue/composition-api';
import { canBeDisabledProp } from '../../../../_composables';
/**
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapAccordionItemProps = {
    ...canBeDisabledProp,
    id: {
        type: String,
        required: true
    },
    isOpen: {
        type: Boolean,
        required: false,
        default: false
    },
    onToggle: {
        type: Function,
        required: false
    },
    label: {
        type: String,
        required: false,
        default: ''
    }
};
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const useBootstrapAccordionItem = (props, ctx) => {
    const { emit } = ctx;
    const { isOpen } = toRefs(props);
    /**
     * Reference to the `.accordion-collapse` element.
     */
    const collapseRef = ref(null);
    /**
     * Value for the `max-height` declaration of the `.accordion-collapse` element.
     */
    const collapseMaxHeight = ref('0px');
    /**
     * Opens (reveals) the `.accordion-collapse` element.
     */
    const open = () => {
        if (collapseRef.value === null) {
            throw new Error('BootstrapAccordionItem.watch(isOpen): [collapseRef.value] is [null]!');
        }
        collapseMaxHeight.value = collapseRef.value.scrollHeight + 'px';
    };
    /**
     * Collapses (closes) the `.accordion-collapse` element.
     */
    const collapse = () => { collapseMaxHeight.value = '0px'; };
    /**
     * Updates the value of the `collapseMaxHeight` ref.
     */
    const updateMaxHeight = () => { isOpen.value ? open() : collapse(); };
    watch(isOpen, updateMaxHeight);
    onMounted(updateMaxHeight);
    /**
     * Handles the `@click` event on the toggler button.
     */
    const onTogglerClick = () => {
        if (props.onToggle && !props.onToggle()) {
            return;
        }
        emit('toggle');
    };
    return { collapseMaxHeight, collapseRef, onTogglerClick, updateMaxHeight };
};
